<div class="min-h-screen pb-page-bottom">
  <app-block-list [blockIdList]="body"></app-block-list>
</div>
<router-outlet></router-outlet>
